import client from './client';

export const listSessions = async (params = {}) => {
  const { data } = await client.get('/sessions', { params });
  return data;
};

export const getSession = async (id) => {
  const { data } = await client.get(`/sessions/${id}`);
  return data;
};

export const createSession = async (payload) => {
  const { data } = await client.post('/sessions', payload);
  return data;
};

export const updateSession = async (id, payload) => {
  const { data } = await client.put(`/sessions/${id}`, payload);
  return data;
};

export const deleteSession = async (id) => {
  const { data } = await client.delete(`/sessions/${id}`);
  return data;
};

export const syncBbbSession = async (id) => {
  const { data } = await client.post(`/sessions/${id}/bbb-sync`, { fetch: true });
  return data;
};

export default {
  listSessions,
  getSession,
  createSession,
  updateSession,
  deleteSession,
  syncBbbSession,
};
